/*
 *
 * Do not edit directly
 * Generated on Mon, 24 Jun 2024 16:18:26 GMT
 *
 */


const theme = {
  appearances: {
    background: { type: 'variant', values: [ true ] },
    color: {
      type: 'variant',
      values: [
        'brand',   'default',
        'subtle',  'success',
        'danger',  'warning',
        'inverse'
      ]
    },
    padding: {
      type: 'variant',
      values: [ 'micro', 'small', 'medium', 'large', 'extraLarge' ]
    },
    rank: { type: 'variant', values: [ 'primary' ] },
    size: {
      type: 'variant',
      values: [ 'micro', 'small', 'large', 'extraLarge' ]
    }
  },
  rules: [
    { if: { padding: 'micro' }, tokens: { padding: 4, width: 4 } },
    { if: { padding: 'small' }, tokens: { padding: 4, width: 8 } },
    { if: { padding: 'medium' }, tokens: { padding: 4, width: 16 } },
    { if: { padding: 'large' }, tokens: { padding: 4, width: 24 } },
    {
      if: { padding: 'extraLarge' },
      tokens: { padding: 4, width: 32 }
    },
    {
      if: { background: true, padding: 'micro' },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderRadius: 45,
        padding: 4,
        width: 4
      }
    },
    {
      if: { background: true, padding: 'small' },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderRadius: 45,
        padding: 4,
        width: 8
      }
    },
    {
      if: { background: true, padding: 'medium' },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderRadius: 45,
        padding: 4,
        width: 16
      }
    },
    {
      if: { background: true, padding: 'large' },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderRadius: 45,
        padding: 4,
        width: 24
      }
    },
    {
      if: { background: true, padding: 'extraLarge' },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderRadius: 45,
        padding: 4,
        width: 32
      }
    },
    { if: { size: 'micro' }, tokens: { size: 16 } },
    { if: { size: 'small' }, tokens: { size: 20 } },
    { if: { size: 'large' }, tokens: { size: 32 } },
    { if: { color: 'brand' }, tokens: { color: '#4b286d' } },
    { if: { color: 'default' }, tokens: { color: '#414547' } },
    { if: { color: 'subtle' }, tokens: { color: '#676e73' } },
    { if: { color: 'success' }, tokens: { color: '#2b8000' } },
    { if: { color: 'danger' }, tokens: { color: '#c12335' } },
    { if: { color: 'warning' }, tokens: { color: '#b4872c' } },
    { if: { color: 'inverse' }, tokens: { color: '#ffffff' } },
    { if: { size: 'extraLarge' }, tokens: { size: 48 } },
    { if: { rank: 'primary' }, tokens: { color: '#4b286d' } }
  ],
  tokens: {
    backgroundColor: 'transparent',
    borderRadius: 0,
    color: '#414547',
    padding: 0,
    scale: 1,
    size: 24,
    translateX: 0,
    translateY: 0,
    width: 0
  }
}
export default theme
